const articleBanners = document.querySelectorAll('.article-banner');

articleBanners.forEach((el) => {
  const background = el.querySelector('.article-banner__background-inner');

  gsap.to(background, {
    yPercent: windowWidth() < breakpointMd ? 30 : 60,
    autoAlpha: 0.4,
    scrollTrigger: {
      trigger: el,
      start: 'top top',
      end: 'bottom+=100% top',
      scrub: true,
    },
  });
});
